const isProduction = (
  window.location.hostname === 'recurlycheckout.com' ||
  window.location.hostname.endsWith('.recurlycheckout.com')
);

const cookieConsentToken = isProduction
  ? '019a320f-7204-7937-836e-b913b2f69aaf'
  : '019a320f-7204-7937-836e-b913b2f69aaf-test';

function loadOneTrustScript () {
  if (cookieConsentToken) {
    // Create and configure the OneTrust SDK script
    const script = document.createElement('script');
    script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    script.type = 'text/javascript';
    script.setAttribute('charset', 'UTF-8');
    script.setAttribute('data-domain-script', cookieConsentToken);

    // Create OptanonWrapper function before the main script loads
    const inlineScript = document.createElement('script');
    inlineScript.type = 'text/javascript';
    inlineScript.textContent = 'function OptanonWrapper() { }';

    // Append scripts to head
    document.head.appendChild(inlineScript);
    document.head.appendChild(script);
  } else {
    console.warn('OneTrust cookie consent token is not defined.');
  }
}

// Check if DOM is already loaded
if (document.readyState === 'loading') {
  // DOM is still loading, wait for it
  document.addEventListener('DOMContentLoaded', loadOneTrustScript);
} else {
  // DOM is already loaded
  loadOneTrustScript();
}
